import { useQuery } from '@tanstack/react-query'
import { agentInspectorApi } from '@/lib/api'

/**
 * Memory store contents for one agent. Disabled until a skillName is supplied
 * (the Inspector panel passes null while closed) so we never fetch for a
 * collapsed panel.
 */
export function useAgentMemory(skillName: string | null) {
  return useQuery({
    queryKey: ['agent-memory', skillName],
    queryFn: () => agentInspectorApi.memory(skillName as string),
    enabled: Boolean(skillName),
    staleTime: 15_000,
  })
}

/** Skill configuration (tools, schedule, model, decision policy) for one agent. */
export function useAgentSkills(skillName: string | null) {
  return useQuery({
    queryKey: ['agent-skills', skillName],
    queryFn: () => agentInspectorApi.skills(skillName as string),
    enabled: Boolean(skillName),
    staleTime: 60_000,
  })
}
